import {createApp} from 'vue'
import App from './App.vue'
import {Popup} from 'vant'

createApp(App).use(Popup).mount('#app')
